// extracted by mini-css-extract-plugin
export default {"card":"ActivityCard_card__n4C9r","img":"ActivityCard_img__ap6k+","credit":"ActivityCard_credit__WlyIH","title":"ActivityCard_title__NJt22","author":"ActivityCard_author__nTLqG"};